import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MessageCircle, Shield } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import Logo from '../components/Logo';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const openWhatsApp = () => {
    window.open('https://wa.me/919515698775', '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* WhatsApp Floating Button */}
      <button
        onClick={openWhatsApp}
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all hover:scale-110"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-6 w-6" />
      </button>

      {/* Header */}
      <header className="bg-white shadow-sm">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center space-x-3">
            <Logo size={48} />
            <span className="text-2xl font-bold text-gray-900">Reload Freight</span>
          </div>
        </nav>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Button 
          onClick={() => navigate('/')} 
          variant="outline" 
          className="mb-8"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </Button>

        <Card className="shadow-lg">
          <CardContent className="p-8 md:p-12">
            <div className="flex items-center mb-8">
              <Shield className="w-10 h-10 text-blue-600 mr-4" />
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
                Privacy Policy
              </h1>
            </div>

            <div className="space-y-8 text-gray-700">
              {/* Section 1 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  1. Information We Collect
                </h2>
                <p className="mb-3">We may collect:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Name</li>
                  <li>Mobile number</li>
                  <li>Route & trip details</li>
                  <li>Basic contact information</li>
                </ul>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  2. How We Use Information
                </h2>
                <p className="mb-3">Your information is used to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Connect customers and truck owners</li>
                  <li>Communicate booking-related details</li>
                  <li>Provide support when needed</li>
                </ul>
                <p className="mt-3">
                  We do not sell or misuse your data.
                </p>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  3. Data Sharing
                </h2>
                <div className="space-y-3">
                  <p>
                    Information is shared only with relevant users involved in a booking.
                  </p>
                  <p>
                    We do not share data with third parties for marketing purposes.
                  </p>
                </div>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  4. Data Security
                </h2>
                <p>
                  We take reasonable steps to protect user information but cannot guarantee complete security of online data.
                </p>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  5. User Consent
                </h2>
                <p>
                  By using ReLoad Freight, you consent to this Privacy Policy.
                </p>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  6. Policy Updates
                </h2>
                <p>
                  This policy may be updated as services grow.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-3">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <Logo size={36} />
              <span className="text-xl font-bold">Reload Freight</span>
            </div>
            <p className="text-gray-300">
              © 2025 Reload Freight Technologies Private Limited | All rights reserved
            </p>
            <p className="text-gray-400 text-sm">
              Contact: +91 9515698775
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
